import API from '../../../helpers/request/api';

const api = () => new API();

const fetch = () => {
  const query = {
    query: `{
      current_user_info {
        group {
          project {
            project_introduction {
              introduction
              title
              active
            }
          }
        }
      }
    }`,
  };

  return api().get(query);
};

export default {
  fetch,
};



// WEBPACK FOOTER //
// ./src/screens/Index/queries/projectIntroduction.js